import { siteInfo } from '@/mocks/movies';

export default function Features() {
  return (
    <section className="bg-background-950 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">
            为什么选择四虎影院
          </h2>
          <p className="text-sm text-foreground-400 mt-1">极致观影体验，从这里开始</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {siteInfo.features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 rounded-xl bg-background-900/50 border border-background-200/10 hover:border-primary-500/30 transition-all duration-300 group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-4">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-50 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mt-14">
          {[
            { label: '电影资源', value: siteInfo.stats.movies },
            { label: '电视剧资源', value: siteInfo.stats.tvShows },
            { label: '综艺节目', value: siteInfo.stats.variety },
            { label: '动漫作品', value: siteInfo.stats.anime },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-400">
                {stat.value}
              </div>
              <div className="text-xs text-foreground-500 mt-2">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}